import { getIn, useFormikContext } from 'formik'

import { birthDate, dobPassengerTypeMatch, required } from '@lib/validators'
import { CheckoutFormData } from '@pages/Checkout/hooks/useInitialFormValues'
import { useSettings } from '@queries/settings'
import { useCheckout } from '@stores/checkout'

interface UseDOBValidatorProps {
  name: string
  types: Passenger.Type[]
  isMandatory: boolean
}

export const useDOBValidator = ({ name, types, isMandatory }: UseDOBValidatorProps) => {
  const { values } = useFormikContext<CheckoutFormData>()
  const [{ outbound }] = useCheckout()
  const [settings] = useSettings()

  const passengerType = getIn(values, `${name}.type`)
  const travelDate = outbound?.departureTime || ''

  return (value: string) => {
    if (isMandatory) {
      const requiredError = required(value)
      if (requiredError) return requiredError
    }

    if (!value && !isMandatory) {
      return undefined
    }

    if (value) {
      const dateError = birthDate(value)
      if (dateError) return dateError

      if (settings.passengerType?.enabled && types && types.length > 0) {
        const passengerTypeError = dobPassengerTypeMatch(passengerType, types, travelDate)(value)
        if (passengerTypeError) return passengerTypeError
      }
    }

    return undefined
  }
}
